
import { useAuth } from '@/contexts/AuthContext';

export const getUserStorageKey = (baseKey: string): string => {
  // Try to get user email from various sources
  let userEmail = '';
  
  try {
    // Check localStorage for user info
    const authData = localStorage.getItem('supabase.auth.token');
    if (authData) {
      const parsed = JSON.parse(authData);
      userEmail = parsed?.user?.email || '';
    }
  } catch (e) {
    // Fallback - no user specific key
  }

  if (!userEmail) {
    return baseKey;
  }

  // Create a simple hash of the email for the key
  const userHash = btoa(userEmail).replace(/[^a-z0-9]/gi, '_');
  return `${baseKey}_${userHash}`;
};

export const useUserStorage = () => {
  const { user } = useAuth();
  
  const getItem = (key: string) => {
    const userKey = getUserStorageKey(key);
    return localStorage.getItem(userKey);
  };

  const setItem = (key: string, value: string) => {
    const userKey = getUserStorageKey(key);
    localStorage.setItem(userKey, value);
  };

  const removeItem = (key: string) => {
    const userKey = getUserStorageKey(key);
    localStorage.removeItem(userKey);
  };

  return { getItem, setItem, removeItem, user };
};
